import { ErrorCode } from '@afterpaytouch/portal-api'
import { useOfferDetailPBI } from '../../../state'
import { useTranslation } from '../../../utils/convergence'

type PBIRejectedSubheadingKey =
  | 'consumerLending:paymentTypesB:tooManyOrdersSubheading'
  | 'consumerLending:paymentTypesB:accountLimitSubheading'
  | 'consumerLending:paymentTypesB:merchantLimitSubheading'
  | 'consumerLending:paymentTypesB:genericSubheading'

const rejectedReasonCodeKey = (rejectedReasonCode: ErrorCode | undefined): PBIRejectedSubheadingKey => {
  switch (rejectedReasonCode) {
    case ErrorCode.MaxActiveOrdersReached:
      return 'consumerLending:paymentTypesB:tooManyOrdersSubheading'
    case ErrorCode.AmountTooHigh:
    case ErrorCode.OrderAmountTooHigh:
      return 'consumerLending:paymentTypesB:accountLimitSubheading'
    case ErrorCode.MerchantOrderAmountLimitExceeded:
      return 'consumerLending:paymentTypesB:merchantLimitSubheading'
    default:
      return 'consumerLending:paymentTypesB:genericSubheading'
  }
}

export const usePBIRejectedText = (): string => {
  const { t } = useTranslation()
  const offerDetailPBI = useOfferDetailPBI()

  const rejectedReasonCode = offerDetailPBI?.rejectedReasonCode

  switch (rejectedReasonCode) {
    case ErrorCode.MaxActiveOrdersReached:
      return t('consumerLending:paymentTypesB:tooManyOrdersSubheading', {
        interval: offerDetailPBI?.numberOfInstallments,
      })
    case ErrorCode.AmountTooHigh:
    case ErrorCode.OrderAmountTooHigh:
      return t('consumerLending:paymentTypesB:accountLimitSubheading', {
        interval: offerDetailPBI?.numberOfInstallments,
      })
    case ErrorCode.MerchantOrderAmountLimitExceeded:
      return t('consumerLending:paymentTypesB:merchantLimitSubheading', {
        interval: offerDetailPBI?.numberOfInstallments,
      })
    default:
      return t('consumerLending:paymentTypesB:genericSubheading', {
        interval: offerDetailPBI?.numberOfInstallments,
      })
  }
}

export const getPBIRejectedSubheadingKey = rejectedReasonCodeKey
